import {
  Box, LinearProgress,
  Link,
  Skeleton,
  Typography, Grid
} from '@mui/material';
import { withStyles } from '@mui/styles';
import { Table as AntdTable } from 'antd';
import { decode } from 'html-entities';
import moment from 'moment';
import React, { useEffect, useState, useContext, useCallback } from 'react';
import ReactApexChart from "react-apexcharts";
import toast from 'react-hot-toast';
import styled from 'styled-components';
import { ReactComponent as ReportChart } from "../assets/icons/icon-report-data.svg";
import AreaChart from '../components/charts/AreaChart';
import BarChart from '../components/charts/BarChart';
import ClusteredBarComboChart from '../components/charts/ClusteredBarComboChart';
import DonutChart from '../components/charts/DonutChart';
import FunnelChart from '../components/charts/FunnelChart';
import HistogramChart from '../components/charts/HistogramChart';
import HorizontalBarChart from '../components/charts/HorizontalBarChart';
import MultiAxisBarComboChart from '../components/charts/MultiAxisBarComboChart';
import PieChart from '../components/charts/PieChart';
import ScatterChart from '../components/charts/ScatterChart';
import StackedBarComboChart from '../components/charts/StackedBarComboChart';
import TreeMapChart from '../components/charts/TreeMapChart';
import VerticalStackedBar from '../components/charts/VerticalStackedBar';
import { LimitAllowedIn } from '../constants/chartType';
import PivotTableRenderer from './PivotTableRenderer';
import { userActivityLog } from '../config/services/activityLog';
import { getDatasetByName } from '../config/services/datasets';
import {
  getMeasuresList
} from '../config/services/measures';
import { getReportById } from '../config/services/reports';
import EnvSettings from "../config/settings";
import { CustomTooltip2, UtcToLocalDate, abbreviateNumber, compactNumberFormatter, formatCurrency, hexToRgb, numberFormatter } from '../utils/Reusables';
import { DecryptData } from '../utils/encryptDecrypt';
import { handleLanguageChange, handleStringLength } from '../utils/multiLangDashboardV2Data';
import { NumberChartRenderer } from './NumberChartRenderer';
import ReportHyperLink from './_report/cards/ReportHyperLink';
import { ComparisonChartSideComponent } from './charts/ComparisonChartSideBarComponent';
import ListViewChart from './charts/static/ListViewChart';
import ProgressViewChart from './charts/static/ProgressViewChart';
import TablePagination from './charts/static/TablePagination';
import { useLocation,Link as NavLink } from "react-router-dom"
import { formatNumberTimeField as reusableFormatNumberTimeField, isMobileView } from '../utils/Reusables';
import TimeViewChart from './charts/static/TimeViewChart';
import HalfGaugeChart from '../components/charts/GaugeChart';
import { ChartsQuickFilter } from './charts/ChartsQuickFilter';
import { useComparisonChartDetails, useReportDetails } from '../layouts/report/ReportDetailsContext';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { NumberChartTitleLength, NumberChartDescriptionLength, ReportCardTitleLength, ReportCardDescriptionLength } from "../constants/stringParams";
import { useQuickFilter } from "../layouts/report/ReportDetailsContext";
import { split } from 'lodash';
import { CURRENCIES } from '../constants/filterType';
import _ from 'lodash';
import { resultSetWrapper } from './mergeResponses';

let reqFlag = false;

const COLORS_SERIES = [
  '#e46179',
  '#80cc8c',
  '#4482ff',
  '#aac6ff',
  '#6F42C1',
  '#ffc37e',
  '#276ce6',
  '#ff926b',
  '#9CD1A4',
  '#da38b8',
  '#ffacbb',
  '#f79c3d',
  '#cc1845',
  '#a0c44b',
  '#5b8ff9',
  '#f45e29',
  '#062C33',
  '#5ad8a6',
  '#5e7092',
  '#f6bd18',
  '#6f5efa',
  '#6ec8ec',
  '#945fb9',
  '#ff9845',
  '#299796',
  '#fe99c3',
  '#9fdef1',
  '#2a5d78',
  '#b9e52f',
  '#ed90c7',
  '#34aeb1',
  '#8c5113',
  '#6197e2',
  '#e436bb',
];

const previousButtonStyle = {
  borderRadius: "4px",
  color: "#F45E29",
  lineHeight: "24px",
  cursor: "pointer",
  display: "inline-block",
  height: '38px',
  fontSize: '25px',
  border: "transparent",
  backgroundColor: "inherit",
}

const paginationButtonPreviousStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  border: '2px solid red',
  borderRadius: '50%',
  height: '25px',
  width: '25px',
  marginRight: '10px',
  marginLeft: '10px',
  padding: '10px'

}

const nextButtonStyle = {
  borderRadius: "4px",
  color: "#F45E29",
  lineHeight: "24px",
  cursor: "pointer",
  display: "inline-block",
  height: '38px',
  fontSize: '25px',
  border: "transparent",
  backgroundColor: "inherit",

}

const Table = styled(AntdTable)`
  ${(props) => {
    const onRowImplementation = props.onRow && props.onRow({})
    if (onRowImplementation?.onClick) {
      return `tbody tr:hover {
          cursor: pointer;
        }        
        `
    }
  }}`

const getRowClassName = (record, index) => {
  if (index % 2 === 0) {
    return 'even-row';
  } else {
    return '';
  }
};

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 8,
    borderRadius: 4,
  },
  colorPrimary: {
    backgroundColor: '#dedede',
  },
  bar: {
    borderRadius: 4,
    backgroundColor: '#F45E29',
  },
}))(LinearProgress);

const HeatMapRender = ({ resultSet, isLegendVisible, dateFieldFormat, columnTitle, columnDisplayName }) => {
  let { loadResponse } = resultSet;
  let dimensionsLength = (loadResponse?.pivotQuery?.dimensions?.length || 0) + (loadResponse?.pivotQuery?.timeDimensions?.length || 0)
  if (dimensionsLength > 2 || dimensionsLength <= 0) {
    return (<div>Require 1 dimension in Row and 1 dimension in Col</div>)
  }

  if (!loadResponse?.pivotQuery?.measures?.length || loadResponse?.pivotQuery?.measures?.length > 1) {
    return (<div>Require 1 measure</div>)
  }
  let dimensionRowKey = loadResponse?.pivotQuery?.dimensions[1];
  let dimensionColKey = loadResponse?.pivotQuery?.dimensions[0];
  let measureKey = loadResponse?.pivotQuery?.measures[0];

  if (loadResponse?.pivotQuery?.timeDimensions?.length > 0) {
    if (loadResponse?.pivotQuery?.timeDimensions?.length === 1) {
      dimensionRowKey = loadResponse?.pivotQuery?.timeDimensions[0]?.dimension;
      if (!dimensionColKey) {
        dimensionColKey = loadResponse?.pivotQuery?.timeDimensions[0]?.dimension;
      }
    } else if (loadResponse?.pivotQuery?.timeDimensions?.length === 2) {
      dimensionRowKey = loadResponse?.pivotQuery?.timeDimensions[1]?.dimension;
      dimensionColKey = loadResponse?.pivotQuery?.timeDimensions[0]?.dimension;
    }
  }

  if (!dimensionRowKey)
    dimensionRowKey = dimensionColKey;

  let dataRow = [];
  loadResponse?.results.length > 0 && loadResponse?.results[0]?.data?.forEach((obj) => {
    let row = dataRow.find((r) => r.x === obj[dimensionRowKey]);
    if (!row) {

      if (dateFieldFormat && Object.keys(dateFieldFormat).length) {

        for (let [key, val] of Object.entries(dateFieldFormat)) {
          let [field, type] = key.split('_')
          if (dimensionRowKey === field && obj[dimensionRowKey] && type === 'date') {
            let formatted = moment(obj[dimensionRowKey])
            if (formatted.isValid()) {
              obj[dimensionRowKey] = formatted.format(val)
              dataRow.push({
                x: obj[dimensionRowKey] || "",
                y: 0
              })
            }
          }
          else if (dimensionRowKey === field && obj[dimensionRowKey]) {
            const formatted = formatNumberTimeField(obj[dimensionRowKey], dateFieldFormat[key], type);
            obj[dimensionRowKey] = formatted
            dataRow.push({
              x: obj[dimensionRowKey] || "",
              y: 0
            })
          }
        }
      }
      else {
        dataRow.push({
          x: obj[dimensionRowKey] || "",
          y: 0
        })
      }
    }
  })

  let series = [];
  loadResponse?.results.length > 0 && loadResponse?.results[0]?.data?.forEach((obj) => {
    let index = series.findIndex((s) => s.name === obj[dimensionColKey]);
    if (index < 0) {
      let dataRowList = dataRow?.map((list) => {
        return {
          x: list.x,
          y: list.y
        }
      }).reverse();


      if (dateFieldFormat && Object.keys(dateFieldFormat).length) {

        for (let [key, val] of Object.entries(dateFieldFormat)) {
          let [field, type] = key.split('_')
          if (dimensionColKey === field && obj[dimensionColKey] && type === 'date') {
            let formatted = moment(obj[dimensionColKey])
            if (formatted.isValid()) {
              obj[dimensionColKey] = formatted.format(val)
              series.push({
                name: obj[dimensionColKey] || "",
                data: dataRowList
              })
            }
          }
          else if (dimensionColKey === field && obj[dimensionColKey]) {
            const formatted = formatNumberTimeField(obj[dimensionColKey], dateFieldFormat[key], type);
            obj[dimensionColKey] = formatted
            series.push({
              name: obj[dimensionColKey] || "",
              data: dataRowList
            })
          }
        }

      }
      else {
        series.push({
          name: obj[dimensionColKey] || "",
          data: dataRowList
        })
      }
      index = series.length - 1;
    }

    let rowIndex = series[index]?.data?.findIndex((row) => row.x === obj[dimensionRowKey]);
    if (rowIndex >= 0) {
      series[index].data[rowIndex].y = obj[measureKey];
    }
  })

  let title = "";
  if (dimensionRowKey && dimensionColKey && measureKey) {
    if (measureKey.split(".").length > 1 && dimensionRowKey.split('.').length > 1 && dimensionColKey.split('.').length > 1) {

      title = `${columnTitle.length && columnTitle[measureKey] ? columnTitle[measureKey] : columnDisplayName && columnDisplayName[measureKey] ? columnDisplayName[measureKey] : measureKey.split(".")[1]} by ${columnTitle.length && columnTitle[dimensionRowKey] ? columnTitle[dimensionRowKey] : columnDisplayName && columnDisplayName[dimensionRowKey] ? columnDisplayName[dimensionRowKey] : dimensionRowKey.split('.')[1]}`;

      if (dimensionColKey !== dimensionRowKey) {
        title = title + " and " + columnTitle.length && columnTitle[dimensionRowKey] ? columnTitle[dimensionRowKey] : columnDisplayName && columnDisplayName[dimensionRowKey] ? columnDisplayName[dimensionRowKey] : dimensionColKey.split('.')[1]
      }
    }
  }

  const options = {
    chart: {
      height: 350,
      type: "heatmap"
    },
    title: {
      text: title,
      align: 'left'
    },
    legend: {
      position: 'right',
      offsetX: 0,
      offsetY: 50,
      show: isLegendVisible
    },
    dataLabels: {
      enabled: true,
      style: {
        colors: ["black"]
      },
      formatter: (v) => {
        return v ? v : "";
      }
    },
    colors: COLORS_SERIES,
    xaxis: {
      labels: {
        formatter: (v) => {
          return v;
        }
      }
    },
    yaxis: {
      labels: {
        formatter: (v) => {
          return v;
        }
      }
    }
  };

  if (!series?.length) {
    return <div>No Data for given dimension and measure</div>
  }

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="heatmap"
      height={500}
    />
  )
}

const TypeToChartComponent = {
  timeView: ({ resultSet, columnTitle, isLegendVisible, dateFieldFormat, legendPosition, pivotConfig, columnDisplayName, settings, fieldsKeyInfo }) => {
    return <TimeViewChart resultSet={resultSet} columnTitle={columnTitle} isLegendVisible={isLegendVisible} dateFieldFormat={dateFieldFormat} legendPosition={legendPosition} pivotConfig={pivotConfig} columnDisplayName={columnDisplayName} settings={settings} fieldsKeyInfo={fieldsKeyInfo} />

  },
  listView: ({ resultSet, columnTitle, isLegendVisible, dateFieldFormat, legendPosition, pivotConfig, columnDisplayName, settings, fieldsKeyInfo }) => {
    return <ListViewChart resultSet={resultSet} columnTitle={columnTitle} isLegendVisible={isLegendVisible} dateFieldFormat={dateFieldFormat} legendPosition={legendPosition} pivotConfig={pivotConfig} columnDisplayName={columnDisplayName} settings={settings} fieldsKeyInfo={fieldsKeyInfo} />
  },
  progressView: ({ resultSet, columnTitle, isLegendVisible, dateFieldFormat, legendPosition, pivotConfig, columnDisplayName, settings, fieldsKeyInfo }) => {
    return <ProgressViewChart resultSet={resultSet} columnTitle={columnTitle} isLegendVisible={isLegendVisible} dateFieldFormat={dateFieldFormat} legendPosition={legendPosition} pivotConfig={pivotConfig} columnDisplayName={columnDisplayName} settings={settings} fieldsKeyInfo={fieldsKeyInfo} />
  },
  scatter: ({ resultSet, columnTitle, isLegendVisible, dateFieldFormat, legendPosition, pivotConfig, columnDisplayName, settings, timeDimensionDateFormat, handleCategoryData }) => {
    return <ScatterChart resultSet={resultSet} COLORS_SERIES={COLORS_SERIES} isLegendVisible={isLegendVisible} pivotConfig={pivotConfig} dateFieldFormat={dateFieldFormat} handleCategoryData={handleCategoryData} columnTitle={columnTitle} legendPosition={legendPosition} columnDisplayName={columnDisplayName} settings={settings} timeDimensionDateFormat={timeDimensionDateFormat} />
  },
  histogram: ({ resultSet, pivotConfig, columnTitle, dateFieldFormat, isLegendVisible, legendPosition, columnDisplayName, settings, timeDimensionDateFormat, handleCategoryData }) => {
    return <HistogramChart resultSet={resultSet} COLORS_SERIES={COLORS_SERIES} isLegendVisible={isLegendVisible} pivotConfig={pivotConfig} dateFieldFormat={dateFieldFormat} handleCategoryData={handleCategoryData} columnTitle={columnTitle} legendPosition={legendPosition} columnDisplayName={columnDisplayName} settings={settings} timeDimensionDateFormat={timeDimensionDateFormat} />
  },
  pie: ({ resultSet, columnTitle, dateFieldFormat, isLegendVisible, legendPosition, pivotConfig, columnDisplayName, settings, timeDimensionDateFormat, handleCategoryData }) => {
    return <PieChart resultSet={resultSet} isLegendVisible={isLegendVisible} COLORS_SERIES={COLORS_SERIES} dateFieldFormat={dateFieldFormat} handleCategoryData={handleCategoryData} columnTitle={columnTitle} legendPosition={legendPosition} pivotConfig={pivotConfig} columnDisplayName={columnDisplayName} settings={settings} timeDimensionDateFormat={timeDimensionDateFormat} />
  },
  number: NumberChartRenderer,
  numberGraphicCard: NumberChartRenderer, // this case also handled in NumberChartRenderer
  gauge: ({ resultSet, columnTitle, dateFieldFormat, isLegendVisible, legendPosition, pivotConfig, columnDisplayName, settings, timeDimensionDateFormat, handleCategoryData }) => {
    return <HalfGaugeChart resultSet={resultSet} isLegendVisible={isLegendVisible} COLORS_SERIES={COLORS_SERIES} dateFieldFormat={dateFieldFormat} handleCategoryData={handleCategoryData} columnTitle={columnTitle} legendPosition={legendPosition} pivotConfig={pivotConfig} columnDisplayName={columnDisplayName} settings={settings} timeDimensionDateFormat={timeDimensionDateFormat} />
  },
  table: ({ location,resultSet, pivotConfig, columnTitle, noDataText, dateFieldFormat, columnDisplayName, fieldFormat, reportHyperlink, query, setHyperlinkModal, setHyperlinkReportData, setLoader, setHyperlinkExtUrl, setHyperlinkType, setUserInfo, setExtReportType, currentPage, setCurrentPage, orderBy, TABLE_PAGE_SIZE, settings, timeDimensionDateFormat, totalRecords, setTotalRecords, currpage, setCurrPage, updateReportOrderBy, tableColumnnsView, hiddenFields, h = null, reportIn = null, hasFilters = null, hasLinkedReports = null, reportDetails, reportOfLinkedType, combinedResults ,isDashboardView = false}) => {
    let result = { tablePivot: [] }

    const totalData = resultSet?.loadResponse?.results?.[0]?.total
    //console.log(query.limit,totalData)
    settings.pageSize = settings?.pageSize || TABLE_PAGE_SIZE
    let totalPages = totalData ? Math.ceil(totalData / query.limit) : 0
    let { timeDimensions } = resultSet?.decompose()?.[0]?.query() ?? []

    let TimeGranularityKey = null
    let GranularityDateFormat = ''
    let groupBySettings = settings?.groupBySettings
    let downloadable = settings?.downloadable
    let truncateSettings = settings?.truncateSettings
    let isDashboardReportNonPaginated = (reportIn === "dashboard");
    /* 224 - card padding, header height, filter height, margin above chart; 54 - filter height, linked reports - 64, canvas margin - 16 */
    let topBottomMargins = 40;
    let paginationTextInfoHeight = 20;
    let reportHeaderSpacing = 24 + (reportDetails?.reportDetails?.description ? 19 : 0) + 20;
    let hasLinkedReportsSpacing = hasLinkedReports ? ((reportOfLinkedType === 'CAROUSEL') ? 103 : 55) : 0; // 55 is 35 + 20
    let tablecardSpacing = isDashboardReportNonPaginated ? (topBottomMargins + reportHeaderSpacing + hasLinkedReportsSpacing + paginationTextInfoHeight) : (paginationTextInfoHeight);

    let resultSetNew = null
    let newMergeReport = reportDetails?.reportDetails?.mergeReport
    if(newMergeReport?.length > 0 && combinedResults){
      resultSetNew = resultSetWrapper({mergeReport:newMergeReport, resultSet, combinedData:combinedResults})
    }else{
      resultSetNew = _.cloneDeep(resultSet)
    }


    const tableDefaultHeight = (reportIn === "dashboard")
      ? (isMobileView()
        ? 540
        : ((h * 10) + ((h - 1) * 20) - tablecardSpacing))
      : 500;

    //console.log("jj", reportDetails?.reportDetails?.reportName, h, reportOfLinkedType, tableDefaultHeight)
    if (timeDimensions.length) {
      let { dimension, granularity } = timeDimensions[0]
      TimeGranularityKey = `${dimension ?? ''}.${granularity ?? ''}`

      let dateFormat = 'DD MMM YY'

      switch (granularity) {
        case 'hour':
          dateFormat = dateFormat + " HH a"
          break;
        case 'minute':
          dateFormat = dateFormat + " HH:mm a"
          break;
        case 'second':
          dateFormat = dateFormat + " HH:mm:ss a"
          break;
        case 'month':
          dateFormat = "MMM YY"
          break;
        case 'year':
          dateFormat = "YYYY"
          break;
        default:
          break
      }

      GranularityDateFormat = dateFormat
    }

    // const tableResultSetData = resultSet?.loadResponses?.length ? resultSet?.loadResponses[0]?.data : []
    // let nullKeys = []



    let rowsCount = 1
    //let rawData = resultSet?.tablePivot(pivotConfig)
    //console.log(rawData)
    for (let pivot of resultSetNew?.tablePivot(pivotConfig)) {
      /**Start---This piece of code is to change format of time granularity key Start---*/
      // if(resultSet?.tablePivot(pivotConfig).length === tableResultSetData.length && pivot && Object.keys(pivot).length !== Object.keys(tableResultSetData[0]).length) {

      //     for(let p of Object.keys(pivot)) {
      //       if(!tableResultSetData[0][p]) {
      //         nullKeys.push(p)
      //       }  
      //     }
      //  }
      pivot['serialNo'] = rowsCount
      rowsCount++


      if (timeDimensionDateFormat && Object.values(timeDimensionDateFormat)?.length) {
        for (let f of Object?.values(timeDimensionDateFormat)) {
          let { format, key, granularity } = f
          let granKey = key + '.' + granularity
          if (pivot[granKey] && format) {
            pivot[granKey] = moment(pivot[granKey]).format(format)
          }
          else if (pivot[TimeGranularityKey] && GranularityDateFormat) {
            pivot[TimeGranularityKey] = moment(pivot[TimeGranularityKey]).format(GranularityDateFormat)
          }
        }
      }
      else if (pivot[TimeGranularityKey] && GranularityDateFormat) {
        pivot[TimeGranularityKey] = moment(pivot[TimeGranularityKey]).format(GranularityDateFormat)
      }
      /**End ---This piece of code is to change format of time granularity key---End*/


      if (dateFieldFormat && Object.keys(dateFieldFormat).length) {
        for (let obj of Object.keys(dateFieldFormat)) {
          let [field, type] = obj.split('_')
          if (type === 'date' && pivot[field]) {
            pivot[field] = moment(pivot[field]).format(dateFieldFormat[obj])
          }
          else if (pivot[field]) {
            const formatted = formatNumberTimeField(pivot[field], dateFieldFormat[obj], type);
            pivot[field] = formatted
          }

        }
      }

      if (fieldFormat && Object.keys(fieldFormat).length) {
        for (let obj of Object.keys(fieldFormat)) {
          if (pivot[obj] && (fieldFormat[obj] === 'percentage' || fieldFormat[obj] === 'percent')) {
            pivot[obj] = pivot[obj] + '%'
          }
          else if (pivot[obj] && fieldFormat[obj] === 'number') {
            pivot[obj] = numberFormatter.format(pivot[obj])
          }else if (pivot[obj] && fieldFormat[obj] === 'compactNumber') {
            pivot[obj] = compactNumberFormatter.format(pivot[obj])
          }else if(pivot[obj] && CURRENCIES.indexOf(fieldFormat[obj]) > -1){
            pivot[obj] = formatCurrency(pivot[obj],fieldFormat[obj])
          }
          else if (pivot[obj]) {
            const formatted = reusableFormatNumberTimeField(pivot[obj], fieldFormat[obj]);
            pivot[obj] = formatted
          }
        }
      }

      for (let key of Object.keys(pivot)) {
        // if(nullKeys.includes(key) || pivot[key] === null) {
        //   pivot[key] = ''
        // }

        if (pivot[key] === undefined || pivot[key] === null || pivot[key] === 'NaN') {
          pivot[key] = 'NA'
        }

        if (pivot[key]) {
          pivot[key] = decode(pivot[key])
        }

      }
      result.tablePivot.push(pivot)
    }

    result.tableColumns = resultSetNew?.tableColumns(pivotConfig).map(col => {
      col.title = columnTitle && columnTitle[0] && columnTitle[0][col?.key] ? columnTitle[0][col?.key] : columnDisplayName && columnDisplayName[col?.key] ? columnDisplayName[col?.key] : col?.shortTitle
      if (col && Object.keys(col).length && Object.keys(col).includes('children') && col?.children.length) {
        col.children = col?.children.map(child => {
          return handleInnerChild(child, columnTitle, columnDisplayName)
        })
      }
      return col
    })
    result.tableColumns = result?.tableColumns.map(col => {
      col.render = (value, record, index) => {
        return <div className='re-table-cell' style={{wordWrap: 'break-word'}}>{value}</div>
      }
      return col
    })
    if (reportHyperlink && reportHyperlink.length) {

      result.tableColumns = result?.tableColumns.map(col => {
        if (hiddenFields.find(ele => ele === col.key)) {
          col.hidden = true
        }

        reportHyperlink.forEach(link => {
          const { hyperlinkColumn, hyperlinkReportId, hyperlinkType, hyperlinkExtUrl, hyperlinkExtType, hyperlinkExtParams, hyperlinkExtQryParams, hyperlinkDashboardId } = link;

          if (hyperlinkColumn && hyperlinkType === 'int' && hyperlinkReportId && Object.keys(hyperlinkReportId).length) {

            if (col?.key === hyperlinkColumn) {
              col.render = (text, record, index) => <Box className='re-table-cell'
              > <a className='table-report-link' href="#" style={{ cursor: 'pointer' }} onClick={
                (e) => {
                  e.preventDefault();
                  //setHyperlinkType(hyperlinkType)
                  //setHyperlinkModal(true);
                  handleReportHyperlink(link, record, setHyperlinkReportData, query,hyperlinkType,setHyperlinkModal,setHyperlinkType,reportDetails)
                }
              } > {text} </a></Box >
            }

          }
          else if (hyperlinkColumn && hyperlinkType === 'ext' && hyperlinkExtUrl) {

            let url = hyperlinkExtUrl;
            const target = link?.hyperLinkExtWindow === "new_window" ? "_blank" : link?.hyperLinkExtWindow === "same_window" ? "_parent" : undefined;

            if (col?.key === hyperlinkColumn) {
              col.render = (text, record, index) => <Box className='re-table-cell'
              >
                {
                  target
                    ? (
                      <a
                        className='table-report-link'
                        href={target ? getHyperlinkLink(url, hyperlinkExtParams, hyperlinkExtQryParams, record, query) || '#' : "#"}
                        style={{ cursor: 'pointer' }}
                        target={target}
                      >
                        {text}
                      </a>
                    )
                    : (
                      <a
                        className='table-report-link'
                        href={"#"}
                        style={{ cursor: 'pointer' }}
                        onClick={
                          (e) => {
                            e.preventDefault();
                            if (target) return
                            setHyperlinkType(hyperlinkType)
                            if (hyperlinkExtType === "params") {
                              handleExternalReportHyperlink(query, record, hyperlinkExtParams, url, hyperlinkExtType, setHyperlinkExtUrl, setHyperlinkModal, setUserInfo, setExtReportType)
                            }
                            else if (hyperlinkExtType === "qryParams") {
                              handleExternalReportHyperlink(query, record, hyperlinkExtQryParams, url, hyperlinkExtType, setHyperlinkExtUrl, setHyperlinkModal, setUserInfo, setExtReportType)
                            }
                            else {
                              setHyperlinkModal(true);
                              setHyperlinkExtUrl(url)
                            }

                          }
                        }
                      >
                        {text}
                      </a>
                    )
                }
              </Box >
            }
          }
          if (hyperlinkColumn && hyperlinkType === 'dashboard') {
            if (col?.key === hyperlinkColumn) {
              col.render = (text, record, index) => {
                let url = `/embedDashboard/${hyperlinkDashboardId?._id}?isRedirect=${isDashboardView}`
                const hyperlinkColumnsForDashboard = link.hyperlinkColumnsForDashboard?.map(item => { return { [item.split('.')[1]]: record[item] } });
                if (hyperlinkColumnsForDashboard?.length > 0) {
                  url = `${url}?filterParams=${encodeURIComponent(JSON.stringify(hyperlinkColumnsForDashboard))}`
                  //url.searchParams.append('filterParams', encodeURIComponent(JSON.stringify(hyperlinkColumnsForDashboard)));
                }
                return (
                  <Box className='re-table-cell'>
                    <NavLink className='table-report-link' to={url} state={{ previousRoute: {...location}}}>{text}</NavLink>
                    {
                    //<a className='table-report-link' href={url.href} style={{ cursor: 'pointer' }} >{text}</a>
                    }
                  </Box>
                )
              }
            }
          }
        })
        return col
      })
    }


    //Handle Conditional Formatting starts//
    if (settings?.conditionalFormat && settings?.conditionalFormat.length) {
      result.tableColumns = result?.tableColumns.map(col => {
        settings?.conditionalFormat.forEach(format => {
          const { columnName,
            visualType,
            color,
            showNumber,
            showCompactNumber,
            alignment,
            decimalPrecision,
            showTarget,
            targetValue
          } = format
          if (col?.key === columnName) {
            col.render = (value, record, index) => {             
              let val = parseFloat(value)
              //console.log(value,visualType,record)
              if (val && !isNaN(val)) {
                let currentDataArr = result?.tablePivot.map(pivot => parseFloat(pivot[col?.key]));
                //console.log(currentDataArr)
                let maxData = Math.max(...currentDataArr)
                let percent = parseFloat((parseInt(val) / parseInt(maxData)))
                //console.log(percent,maxData)
                //let barTargetValue = showTarget ? parseInt(targetValue) : 100
                let barPercent = parseFloat((parseInt(val) / parseInt(((showTarget && targetValue) ? targetValue : maxData))) * 100)
                val = Math.floor(val) === val ? parseInt(val) : parseFloat(val)
                if (decimalPrecision && decimalPrecision !== 'auto') {
                  val = val.toFixed(decimalPrecision)
                }
                //console.log(value,val,color,abbreviateNumber(val))
                switch (visualType) {
                  case 'number':
                    val = showCompactNumber ? abbreviateNumber(val) : val
                    return <span style={{ ...(color && { color }) }}>{value}</span>
                  case 'bar':
                    if (barPercent > 100) {
                      barPercent = 100
                    }
                    val = showCompactNumber ? abbreviateNumber(val) : val;
                    return <Box sx={{ width: '100%', mt: 1.5 }} className={`re-metrics-progress-align ` + alignment}>
                      <Box className='re-metrics-progress-align-bar' sx={{ width: '70%' }}>
                        <BorderLinearProgress variant="determinate" value={barPercent} />
                      </Box>
                      {showNumber && <span className='re-metrics-progress-align-value' style={{ ...(color && { color }) }}>{value}</span>}
                    </Box>
                  case 'heatMap':
                    if (percent > 1) {
                      percent = 1
                    }
                    const colorArr = hexToRgb(color)
                    let backgroundColor = `rgb(${colorArr?.join(',')},${percent})`
                    val = Math.floor(val) === val ? parseInt(val) : parseFloat(val)
                    val = showCompactNumber ? abbreviateNumber(val) : val
                    //console.log(val,backgroundColor,abbreviateNumber(val))
                    return <div style={{ background: backgroundColor }}>{value}</div>
                  default:
                    return
                }
              }
            }
          }
        })
        return col
      })
    }
    //Handle Conditional Formatting Ends//


    //for hiding column if field is hidden 
    result.tableColumns = result?.tableColumns?.filter(item => !item.hidden)



    if (downloadable) {

      let downloadableValues = result.tablePivot?.map(fieldObj => {
        let modifiedFieldObj = { ...fieldObj };
        downloadable.forEach(field => {
          if (fieldObj.hasOwnProperty(field)) {
            const url = fieldObj[field]
            modifiedFieldObj[field] = <a className='re-table-cell' href={url} target="_blank" download>Download</a>;
          }
        });
        return modifiedFieldObj;
      });
      result.tablePivot = downloadableValues
    }


    //for concatenation of different fields
    if (groupBySettings?.length) {
      groupBySettings?.forEach((groupBySetting) => {
        const tableColumns = result.tableColumns?.filter((tableColumn) => !groupBySetting?.concatWith?.includes(tableColumn.key))
        const tablePivot = result.tablePivot?.map((tablePivot) => {
          const concatValue = [tablePivot[groupBySetting.concatAt], ...groupBySetting?.concatWith?.map((concatWith) => tablePivot[concatWith])].join(groupBySetting.concatBy);
          return {
            ...tablePivot,
            [groupBySetting.concatAt]: concatValue
          }

        });
        result.tableColumns = tableColumns
        result.tablePivot = tablePivot

      });

    }



    // for truncate of different fields
    if (truncateSettings?.length) {
      truncateSettings?.forEach((truncateSetting) => {
        const tablePivot = result?.tablePivot?.map((tablePivot) => {
          const row = tablePivot[truncateSetting?.truncateAt]?.toString();
          const rowWords = row?.split(truncateSetting?.splitBy)
          const rowWordslen = rowWords?.length
          const truncateValue = rowWords?.slice(0, truncateSetting?.wordLimit).join(',');
          let toolTiptext = rowWords?.slice((truncateSetting?.wordLimit), (rowWordslen))
          let truncatedText = truncateValue;
          if (rowWordslen > truncateSetting?.wordLimit) {
            truncatedText = (
              <>
                {truncateValue}
                <Link underline="hover">
                  {`+${rowWordslen - truncateSetting?.wordLimit} more`}
                </Link>
              </>
            );
          }
          return {
            ...tablePivot,
            [truncateSetting.truncateAt]: toolTiptext && truncatedText ? (
              <CustomTooltip2
                placement="left"
                overlayClassName="re-ant-tooltip"
                title={toolTiptext.join(`   |   `)} >
                <span className=''>{truncatedText ? truncatedText : null}</span>
              </CustomTooltip2>
            ) : null,
          };
        });

        result.tablePivot = tablePivot
      });

    }





    // sorting code 
    const handleSort = (columnKey) => {
      // orderBy is only available for reports in case of dashboards use query.order
      //console.log(columnKey)
      let splitArr = columnKey.split('.')
      if (splitArr.length > 2) {
        splitArr.splice(splitArr.length - 1, 1)
        columnKey = splitArr.join('.')
      }
      const currentSortOrder = query?.order[columnKey] === 'asc' ? 'desc' : 'asc';
      delete query.order[columnKey]
      query.order = { [columnKey]: currentSortOrder, ...query.order }

      updateReportOrderBy(query)
    };

    let sortObj = Object.keys(query?.order)[0]
    let dashboardColumnToBeSorted = Object.entries(query?.order)?.find(([key, _]) => key === sortObj);
    const sortedColumns = result?.tableColumns?.map((column) => {
      //console.log(dashboardColumnToBeSorted,sortObj)
      let obj = {}
      if (column.children) {
        obj = {
          ...column,
          title: column?.title,
        }
      } else {
        obj = {
          ...column,
          sortDirections: ['ascend', 'descend', 'ascend'],
          sorter: (a, b, sortOrder) => { },
          onHeaderCell: (column) => {
            //console.log(column, '------------inside');
            if (column.children) {
              return null
            } else {
              return {
                onClick: () => {
                  //console.log(column)
                  handleSort(column.key)
                },
              }
            }
          },
          title: column?.title,
        }
      }

      let key = column.key
      let splitArr = key?.split('.')
      if (splitArr?.length > 2) {
        splitArr.splice(splitArr.length - 1, 1)
        key = splitArr.join('.')
      }
      //console.log(column)
      if (key == sortObj) {
        return {
          ...obj,
          sortOrder: (dashboardColumnToBeSorted[1] === 'desc') ? 'descend' : 'ascend',
        };
      } else {
        return obj
      }

    });

    result.tableColumns = sortedColumns



    // Mobile View and Expand Option for table

    let mobileDataColumns = null
    let isExpanded = tableColumnnsView?.includes(reportDetails?.reportDetails?._id)
    if (isMobileView() && settings?.mobile?.measureToDiplay?.length && !isExpanded) {
      const mobileColumns = result?.tableColumns?.filter(column => {
        return settings?.mobile?.measureToDiplay?.find(measure => measure?.value === column?.key);
      });
      if (mobileColumns.length > 0) {
        mobileDataColumns = mobileColumns
      }
    }



    const handleNext = () => {
      let nextPage = currpage + 1
      setCurrPage(nextPage)
    }


    const handlePrevious = () => {
      let prevpage = (currpage - 1)
      setCurrPage(prevpage)
    }

    const onTableScroll = (e) => {
      const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
      if (bottom) {
        let nextPage = currpage + 1
        setCurrPage(nextPage)
      }
    }



    let tableHeadingHasTopBorder = isMobileView() ? settings?.mobile?.reportShowBorderForHeading : settings?.web?.reportShowBorderForHeading;
    //if filter has top or bottom oerator dont show pagination
    let hasTopOperator = false
    if (reportDetails?.reportDetails?.reportFilters.length > 0) {
      hasTopOperator = reportDetails?.reportDetails?.reportFilters?.some(obj => (obj.operator == 'top' || obj.operator == 'bottom'));
    }
    let tablePaginationSpacing = (result?.tablePivot?.length > 0 || currpage > 1) && (currpage === 1 && result?.tablePivot?.length < query.limit) || (result?.tablePivot?.length < query.limit) || (hasTopOperator === true) ? 0 : 38;
    //let ComboTableChartSpacing = ((reportDetails?.reportDetails?.quickFilterList?.length > 0) || reportDetails?.reportDetails?.comparisonChartType) ? 20 : 0;

    return (
      <Box className={`ant-table-metrics `
        + ((hasLinkedReports && (reportDetails?.reportDetails?.linkedReportsViewType === 'CAROUSEL'))
          ? ` dash-report-is-linked-report `
          : ` `)
        + (((currpage === 1 && result?.tablePivot?.length < query.limit) || (hasTopOperator === true)) ? ` ` : ` dash-report-table-has-pag `)
        + ` ` + tableDefaultHeight}
        sx={{
          //height: (reportIn === 'dashboard') ? (isMobileView() ? '100%' : ((tableDefaultHeight - ComboTableChartSpacing) + 'px')) : '400px', /* 400px is added for reports page after No.of rows is removed with sticky option */
          //maxHeight:'400px',
          //overflowY: 'auto'
        }}
      //onScroll={onTableScroll}
      >
        {
          result?.tablePivot?.length > 0 ?
            <>
              {query.limit && !hasTopOperator &&
                <div className='ant-table-head-pagination'>
                  <p>{`Page ${currpage}/${totalPages}`}</p>
                </div>
              }
              <Table
                tableLayout={(mobileDataColumns?.length || (result?.tableColumns?.length === 3)) ? 'fixed' : 'auto'}
                className={`re-report-data-metrics table-header-align`
                  + settings.alignment?.header + ` table-dimensions-align-`
                  + settings.alignment?.dimensions
                  + (mobileDataColumns?.length ? ` fixed-layout-mobile ` : ``)
                  + ((result?.tablePivot?.length < 3) ? ` overflow-y-visible ` : ``)
                  + ((tableHeadingHasTopBorder) ? ` table-heading-has-top-border` : ``)
                }
                scroll={{
                  x: (window.innerWidth < 1023 ? '100%' : (100 * result?.tableColumns?.length)),
                  y: isMobileView()
                    ? (tableDefaultHeight - 90)
                    : (tableDefaultHeight - 50 - tablePaginationSpacing) // 50 can be table header max-height
                }} // 90 is table header and pagination
                sticky={false}
                /* onHeaderRow={(columns, index) => {
                  return {
                    onClick: () => {
                      console.log(columns, index)
                      handleSort(columns[index].key)
                    },
                  };
                }} */
                pagination={false}
                columns={mobileDataColumns || result?.tableColumns}
                dataSource={result?.tablePivot}
                rowKey={'serialNo'}
                //rowClassName={getRowClassName}
                showSorterTooltip={false}
              /></> :
            <Box className="width-100 text-center height-300" >
              <Box className='er-report-data-icon'><ReportChart /></Box>
              <Box>
                <Typography className="er-report-data-info" variant='h4'>{handleLanguageChange(noDataText || 'No Data Found')}</Typography>
              </Box>
            </Box>
        }

        {

          (!query.limit || (currpage === 1 && result?.tablePivot?.length < query.limit) || (hasTopOperator === true)) ? null :
            <div style={{ textAlign: 'center' }}>
              <button title={currpage > 1 ? "Go to previous page" : ""} style={previousButtonStyle} onClick={handlePrevious} disabled={currpage <= 1 ? true : false} >
                <div style={paginationButtonPreviousStyle}>{"<"}</div>
              </button>
              <button title={"Go to Next page"} style={nextButtonStyle} onClick={handleNext} disabled={result?.tablePivot?.length < query.limit || currpage === totalPages}><div style={paginationButtonPreviousStyle}>{">"}</div>
              </button>
            </div>

        }
      </Box>
    );
  },
  pivotTable: ({ resultSet, query, getPivotColState, gridColumnApi, setGridColumnApi, columnState, openToolBar, isPivotEnabled, dateFieldFormat, columnTitle, pivotConfig, columnDisplayName, timeDimensionDateFormat }) => {
    return (
      <PivotTableRenderer graphData={resultSet} query={query} getPivotColState={getPivotColState}
        gridColumnApi={gridColumnApi} setGridColumnApi={setGridColumnApi} columnState={columnState} openToolBar={openToolBar}
        isPivotEnabled={isPivotEnabled} dateFieldFormat={dateFieldFormat} columnTitle={columnTitle} pivotConfig={pivotConfig}
        columnDisplayName={columnDisplayName} timeDimensionDateFormat={timeDimensionDateFormat} />
    );
  },

  donut: ({ resultSet, columnTitle, isLegendVisible, dateFieldFormat, legendPosition, pivotConfig, columnDisplayName, settings, timeDimensionDateFormat, handleCategoryData }) => {
    return <DonutChart resultSet={resultSet} isLegendVisible={isLegendVisible} COLORS_SERIES={COLORS_SERIES} dateFieldFormat={dateFieldFormat} handleCategoryData={handleCategoryData} columnTitle={columnTitle} legendPosition={legendPosition} pivotConfig={pivotConfig} columnDisplayName={columnDisplayName} settings={settings} timeDimensionDateFormat={timeDimensionDateFormat} />;
  },
  treemap: ({ resultSet, isLegendVisible, pivotConfig, dateFieldFormat, columnTitle, legendPosition, columnDisplayName, settings, timeDimensionDateFormat, handleCategoryData }) => {
    return <TreeMapChart resultSet={resultSet} COLORS_SERIES={COLORS_SERIES} isLegendVisible={isLegendVisible} pivotConfig={pivotConfig} dateFieldFormat={dateFieldFormat} handleCategoryData={handleCategoryData} columnTitle={columnTitle} legendPosition={legendPosition} columnDisplayName={columnDisplayName} type='bar' settings={settings} timeDimensionDateFormat={timeDimensionDateFormat} />
  },
  heatmap: ({ resultSet, isLegendVisible, dateFieldFormat, columnTitle, legendPosition, columnDisplayName }) => {
    return <HeatMapRender resultSet={resultSet} isLegendVisible={isLegendVisible} dateFieldFormat={dateFieldFormat} columnTitle={columnTitle} legendPosition={legendPosition} columnDisplayName={columnDisplayName} />
  },
  verticalStackedBarChart100: ({ resultSet, isLegendVisible, dateFieldFormat, columnTitle, legendPosition, pivotConfig, columnDisplayName, settings, timeDimensionDateFormat, handleCategoryData }) => {
    return <VerticalStackedBar resultSet={resultSet} COLORS_SERIES={COLORS_SERIES} verticalType={true} isLegendVisible={isLegendVisible} dateFieldFormat={dateFieldFormat} handleCategoryData={handleCategoryData} columnTitle={columnTitle} legendPosition={legendPosition} pivotConfig={pivotConfig} columnDisplayName={columnDisplayName} settings={settings} timeDimensionDateFormat={timeDimensionDateFormat} />
  },
  horizontalStackedBarChart100: ({ resultSet, isLegendVisible, dateFieldFormat, columnTitle, legendPosition, pivotConfig, columnDisplayName, settings, timeDimensionDateFormat, handleCategoryData }) => {
    return <VerticalStackedBar resultSet={resultSet} COLORS_SERIES={COLORS_SERIES} verticalType={false} isLegendVisible={isLegendVisible} dateFieldFormat={dateFieldFormat} handleCategoryData={handleCategoryData} columnTitle={columnTitle} legendPosition={legendPosition} pivotConfig={pivotConfig} columnDisplayName={columnDisplayName} settings={settings} timeDimensionDateFormat={timeDimensionDateFormat} />
  },
  clusteredBarCombo: ({ resultSet, isLegendVisible, pivotConfig, dateFieldFormat, columnTitle, legendPosition, columnDisplayName, settings, timeDimensionDateFormat, h = null, reportIn = null, hasFilters = null, hasLinkedReports = null, comparisonChartType = false, handleCategoryData }) => {
    return <ClusteredBarComboChart resultSet={resultSet} COLORS_SERIES={COLORS_SERIES} isLegendVisible={isLegendVisible} pivotConfig={pivotConfig} dateFieldFormat={dateFieldFormat} handleCategoryData={handleCategoryData} columnTitle={columnTitle} legendPosition={legendPosition} columnDisplayName={columnDisplayName} settings={settings} timeDimensionDateFormat={timeDimensionDateFormat} h={h} reportIn={reportIn} hasFilters={hasFilters} hasLinkedReports={hasLinkedReports} comparisonChartType={comparisonChartType} />
  },
  multiAxisBarCombo: ({ resultSet, isLegendVisible, pivotConfig, dateFieldFormat, columnTitle, legendPosition, columnDisplayName, settings, timeDimensionDateFormat, h = null, reportIn = null, hasFilters = null, hasLinkedReports = null, comparisonChartType = false, handleCategoryData }) => {
    return <MultiAxisBarComboChart resultSet={resultSet} COLORS_SERIES={COLORS_SERIES} isLegendVisible={isLegendVisible} pivotConfig={pivotConfig} dateFieldFormat={dateFieldFormat} handleCategoryData={handleCategoryData} columnTitle={columnTitle} legendPosition={legendPosition} columnDisplayName={columnDisplayName} settings={settings} timeDimensionDateFormat={timeDimensionDateFormat} h={h} reportIn={reportIn} hasFilters={hasFilters} hasLinkedReports={hasLinkedReports} comparisonChartType={comparisonChartType} />
  },
  area: ({ resultSet, isLegendVisible, pivotConfig, dateFieldFormat, columnTitle, legendPosition, columnDisplayName, settings, timeDimensionDateFormat, h = null, reportIn = null, hasFilters = null, hasLinkedReports = null, comparisonChartType = false, handleCategoryData }) => {
    return <AreaChart resultSet={resultSet} COLORS_SERIES={COLORS_SERIES} isLegendVisible={isLegendVisible} pivotConfig={pivotConfig} dateFieldFormat={dateFieldFormat} handleCategoryData={handleCategoryData} columnTitle={columnTitle} legendPosition={legendPosition} columnDisplayName={columnDisplayName} type='bar' settings={settings} timeDimensionDateFormat={timeDimensionDateFormat} h={h} reportIn={reportIn} hasFilters={hasFilters} hasLinkedReports={hasLinkedReports} comparisonChartType={comparisonChartType} />
  },
  bar: ({ resultSet, isLegendVisible, pivotConfig, dateFieldFormat, columnTitle, legendPosition, columnDisplayName, settings, timeDimensionDateFormat, h = null, reportIn = null, hasFilters = null, hasLinkedReports = null, comparisonChartType, handleCategoryData }) => {
    return <BarChart resultSet={resultSet} COLORS_SERIES={COLORS_SERIES} isLegendVisible={isLegendVisible} pivotConfig={pivotConfig} dateFieldFormat={dateFieldFormat} handleCategoryData={handleCategoryData} columnTitle={columnTitle} legendPosition={legendPosition} columnDisplayName={columnDisplayName} type='bar' settings={settings} timeDimensionDateFormat={timeDimensionDateFormat} h={h} reportIn={reportIn} hasFilters={hasFilters} hasLinkedReports={hasLinkedReports} comparisonChartType={comparisonChartType} />
  },
  line: ({ resultSet, isLegendVisible, pivotConfig, dateFieldFormat, columnTitle, legendPosition, columnDisplayName, settings, timeDimensionDateFormat, h = null, reportIn = null, hasFilters = null, hasLinkedReports = null, comparisonChartType, handleCategoryData }) => {
    return <BarChart resultSet={resultSet} COLORS_SERIES={COLORS_SERIES} isLegendVisible={isLegendVisible} pivotConfig={pivotConfig} dateFieldFormat={dateFieldFormat} handleCategoryData={handleCategoryData} columnTitle={columnTitle} legendPosition={legendPosition} columnDisplayName={columnDisplayName} type='line' settings={settings} timeDimensionDateFormat={timeDimensionDateFormat} h={h} reportIn={reportIn} hasFilters={hasFilters} hasLinkedReports={hasLinkedReports} comparisonChartType={comparisonChartType} />
  },
  horizontalBar: ({ resultSet, isLegendVisible, pivotConfig, dateFieldFormat, columnTitle, legendPosition, columnDisplayName, settings, timeDimensionDateFormat, h = null, reportIn = null, hasFilters = null, hasLinkedReports = null, comparisonChartType = false, handleCategoryData }) => {
    return <HorizontalBarChart resultSet={resultSet} COLORS_SERIES={COLORS_SERIES} isLegendVisible={isLegendVisible} pivotConfig={pivotConfig} dateFieldFormat={dateFieldFormat} handleCategoryData={handleCategoryData} columnTitle={columnTitle} legendPosition={legendPosition} columnDisplayName={columnDisplayName} settings={settings} timeDimensionDateFormat={timeDimensionDateFormat} h={h} reportIn={reportIn} hasFilters={hasFilters} hasLinkedReports={hasLinkedReports} comparisonChartType={comparisonChartType} />
  },
  stackedBarCombo: ({ resultSet, isLegendVisible, pivotConfig, dateFieldFormat, columnTitle, legendPosition, columnDisplayName, settings, timeDimensionDateFormat, h = null, reportIn = null, hasFilters = null, hasLinkedReports = null, comparisonChartType = false, handleCategoryData }) => {
    return <StackedBarComboChart resultSet={resultSet} COLORS_SERIES={COLORS_SERIES} isLegendVisible={isLegendVisible} pivotConfig={pivotConfig} dateFieldFormat={dateFieldFormat} handleCategoryData={handleCategoryData} columnTitle={columnTitle} legendPosition={legendPosition} columnDisplayName={columnDisplayName} settings={settings} timeDimensionDateFormat={timeDimensionDateFormat} h={h} reportIn={reportIn} hasFilters={hasFilters} hasLinkedReports={hasLinkedReports} comparisonChartType={comparisonChartType} />
  },
  funnel: ({ resultSet, isLegendVisible, dateFieldFormat, columnTitle, legendPosition, pivotConfig, columnDisplayName, settings, timeDimensionDateFormat, h = null, reportIn = null, hasFilters = null, hasLinkedReports = null, comparisonChartType = false, handleCategoryData }) => {
    return <FunnelChart resultSet={resultSet} COLORS_SERIES={COLORS_SERIES} isLegendVisible={isLegendVisible} dateFieldFormat={dateFieldFormat} handleCategoryData={handleCategoryData} columnTitle={columnTitle} legendPosition={legendPosition} pivotConfig={pivotConfig} columnDisplayName={columnDisplayName} settings={settings} timeDimensionDateFormat={timeDimensionDateFormat} h={h} reportIn={reportIn} hasFilters={hasFilters} hasLinkedReports={hasLinkedReports} comparisonChartType={comparisonChartType} />;
  },
};

const handleInnerChild = (child, columnTitle, columnDisplayName) => {
  if (child && !Object.keys(child).includes('children')) {

    if ((columnTitle && columnTitle?.length && Object.keys(columnTitle[0])?.length) || (columnDisplayName && Object.keys(columnDisplayName).length)) {

      child.title = columnTitle[0][child?.key] ? columnTitle[0][child?.key] : columnDisplayName[child?.key] ? columnDisplayName[child?.key] : child?.shortTitle
    }
    return child
  }
  else {
    child.title = columnTitle[0][child?.key] ? columnTitle[0][child?.key] : columnDisplayName[child?.key] ? columnDisplayName[child?.key] : child?.shortTitle
    child.children = child?.children.map(child => {
      return handleInnerChild(child, columnTitle)
    })
    return child
  }
}

const formatXAxisValues = (strngValue, dateFormat, timDimFormat) => {
  //console.log(dateFormat,timDimFormat,strngValue)
  let CommaSeperatedValues = strngValue.split(',')
  let labelValue = []
  CommaSeperatedValues.forEach((label, index) => {
    let FormattedLabel = moment(label)

    if (FormattedLabel.isValid() && isNaN(label))

      if (timDimFormat && timDimFormat[index] && timDimFormat[index]?.format)
        labelValue.push(FormattedLabel.format(timDimFormat[index]?.format))
      else
        labelValue.push(FormattedLabel.format(dateFormat))
    else
      labelValue.push(label)
  })
  return labelValue.join('\n')
}

// const handleChartLabel = (columnTitle, columnDisplayName, s) => {

//   let label;
//   let key = s?.key
//   let columnLabel = { ...columnDisplayName }
//   if (columnTitle && columnTitle.length && Object.keys(columnTitle[0]).length) {
//     for (let title of Object.keys(columnTitle[0])) {
//       if (columnTitle[0][title]) {
//         columnLabel[title] = columnTitle[0][title]
//       }
//     }
//   }

//   if (key && columnLabel && Object.keys(columnLabel).length && columnLabel[key]) {
//     label = columnLabel[key]
//     if (Object.keys(columnLabel).length === 1) {
//       if (columnLabel[key].trim() === '') {
//         label = label.replace(',', '')
//       }
//     }
//     else {
//       for (let index = 0; index < Object.keys(columnLabel).length; index++) {
//         if (index !== 0) {
//           if (key === Object.keys(columnLabel)[index] && columnLabel[Object.keys(columnLabel)[index - 1]].trim() === '') {
//             label = columnLabel[key].replace(',', '')
//           }
//         }
//       }
//     }
//   }
//   else if (key && columnLabel && Object.keys(columnLabel).length) {
//     for (let col of Object.keys(columnLabel)) {
//       if (key.includes(col)) {
//         let temp = key;
//         if (columnLabel[col].trim() === '') {
//           key = key.replace(`,${col}`, columnLabel[col]);
//           if (temp === key) {
//             key = key.replace(col, columnLabel[col]);
//           }
//         }
//         else {
//           key = key.replace(col, columnLabel[col]);
//         }
//         label = key;
//       }
//     }
//   }
//   else {
//     label = s?.title
//   }
//   return label;
// }

function getHyperlinkLink(url, params, queryParams, record, query) {
  //console.log('HyperLink',query)
  let filters = query.filters.filter(obj => ['equals',"inDateRange"].indexOf(obj.operator) > -1).map(obj => {return {member: obj.member.split('.')[1],value: `[${obj.values.join(',')}]`}})
  //console.log(queryParams,params,filters)
  //return
  const urlRegex = /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/ig
  if (!urlRegex.test(url)) {
    toast.error('URL is not valid');
    return
  }

  let currentDataSetName = null;
  if (query && query?.dimensions.length) {
    currentDataSetName = query?.dimensions[0].split('.')[0]
  }
  if (query && query?.measures.length) {
    currentDataSetName = query?.measures[0].split('.')[0]
  }
  else if (query && query?.timeDimensions.length) {
    currentDataSetName = query.timeDimensions[0].dimension?.split('.')[0]
  }

  let newUrl = new URL(url);
  //console.log(newUrl)
  if (params) {
    let paramValues = params.map(field => {
      return record[currentDataSetName + '.' + field]
    })
    const newUrlParts = newUrl.toString().split('?');
    //console.log(paramValues)
    if(newUrlParts.length > 1) {      
      newUrl = new URL([`${newUrlParts[0]}/${paramValues.join("/")}`, newUrlParts[1]].join('?'));
    } else {
      newUrl = new URL(`${newUrlParts[0]}/${paramValues.join("/")}`);
    }
  }
  const searchParams = new URLSearchParams(newUrl.search);
  if(filters.length > 0){
    filters.forEach(filter => {
      searchParams.set(filter.member, filter.value);
    });
  }
  if (queryParams) {
    queryParams.forEach(query => {
      if (query?.name && query?.field){
        const value = record[currentDataSetName + '.' + query?.field];
        searchParams.set(query?.name, value);
      }
    });    
  }
  if (searchParams.toString().length > 0)
    newUrl.search = searchParams.toString();

  return newUrl;
}

const handleExternalReportHyperlink = (query, record, extData, url, type, setHyperlinkExtUrl, setHyperlinkModal, setUserInfo, setExtReportType) => {
  //console.log(extData,type,url)
  const urlRegex = /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/ig
  if (!urlRegex.test(url)) {
    toast.error('URL is not valid');
    return
  }
  let hyperlinkUrl = url
  let currentDataSetName = null;
  if (query && query?.dimensions.length) {
    currentDataSetName = query?.dimensions[0].split('.')[0]
  }
  if (query && query?.measures.length) {
    currentDataSetName = query?.measures[0].split('.')[0]
  }
  else if (query && query?.timeDimensions.length) {
    currentDataSetName = query.timeDimensions[0].dimension?.split('.')[0]
  }

  let parsedUrl = new URL(hyperlinkUrl)
  let isOrigin = parsedUrl?.origin === window.location.origin
  //console.log(query)
  //return
  if (isOrigin && parsedUrl?.pathname == '/getUserInfoByUuid') {
    if (type === "params") {
      toast.error('Query Params required for User Info')
      return;
    }
    else if (type === "qryParams") {
      if (extData && extData.length > 0 && Object.values(extData[0]).length > 0 && !Object.values(extData[0]).includes('')) {
        if (extData.length === 1) {
          const { name, field } = extData[0]
          if (name.toLowerCase() !== 'uuid') {
            toast.error('Field should be uuid to get user info');
            return
          }
          else {
            //console.log(record, currentDataSetName,name, field)
            let uuid = record[currentDataSetName + '.' + field];
            //console.log(uuid)
            setExtReportType("getUserInfoByUuid")
            setUserInfo({ name, uuid })
            setHyperlinkModal(true)
          }
        }
        else {
          toast.error('One UUID is required for User Info');
          return
        }
      }
      else {
        toast.error('URL Query Params is required')
        return;
      }
    }
  }
  else {

    setExtReportType("")
    setUserInfo(null)

    if (type === "params") {
      //console.log(extData)
      if (extData && extData.length) {
        extData.forEach(param => {
          const value = record[currentDataSetName + '.' + param]
          hyperlinkUrl += `/${value}`
        })
        setHyperlinkModal(true)
        setHyperlinkExtUrl(hyperlinkUrl)
      }
      else {
        toast.error('URL Params is required')
        return;
      }
    }
    else if (type === "qryParams") {
      if (extData && extData.length && Object.values(extData[0]).length && !Object.values(extData[0]).includes('')) {
        extData.forEach((qry, index) => {
          const { name, field } = qry;

          if (name && field) {
            const value = record[currentDataSetName + '.' + field]

            if (extData.length === 1) {
              hyperlinkUrl += `?${name}=${value}`
            }
            else {
              if (index === 0) {
                hyperlinkUrl += `?${name}=${value}&`
              }
              else if (index > 0 && index < extData.length - 1) {
                hyperlinkUrl += `${name}=${value}&`
              }
              else {
                hyperlinkUrl += `${name}=${value}`
              }
            }

          }
        })
        console.log(hyperlinkUrl)
        setHyperlinkModal(true)
        setHyperlinkExtUrl(hyperlinkUrl)
      }
      else {
        toast.error('URL Query Params is required')
        return;
      }
    }
  }
}

const handleReportHyperlink = async (hyperlinkData, record, setHyperlinkReportData, query, hyperlinkType, setHyperlinkModal, setHyperlinkType,reportDetails=null) => {
  setHyperlinkModal(true)
  const { hyperlinkFilters, hyperlinkReportId } = hyperlinkData;
  getReportById({ reportId: hyperlinkReportId?._id }).then(async result => {
    let report = result?.result
    if (report && hyperlinkFilters?.length) {
      let currentDataSetName = null;
      let hyperlinkDatasetName = report.dataSetId?.dataSetName;

      if(reportDetails?.reportDetails?.dataSetId?.dataSetName){
        currentDataSetName = reportDetails?.reportDetails?.dataSetId?.dataSetName
      }
      else if (query && query?.dimensions.length) {
        currentDataSetName = query?.dimensions[0].split('.')[0]
      }
      else if (query && query?.measures.length) {
        currentDataSetName = query?.measures[0].split('.')[0]
      }
      else if (query && query?.timeDimensions.length) {
        currentDataSetName = query.timeDimensions[0].dimension?.split('.')[0]
      }

      if(!hyperlinkDatasetName){
        if (report && report?.dimensions.length) {
          hyperlinkDatasetName = report?.dimensions[0]?.fieldName.split('.')[0]
        }
        if (report && report?.measures.length) {
          hyperlinkDatasetName = report?.measures[0]?.fieldName.split('.')[0]
        }
        else if (report && report?.timeDimensions.length) {
          hyperlinkDatasetName = report.timeDimensions[0].dimension?.split('.')[0]
        }
      }      

      const combindedFilter = [...report.reportFilters]
      const parentFilters = [
        ...query?.filters,
        ...hyperlinkFilters?.map(measure => {
          return {
            member: hyperlinkDatasetName + '.' + measure,
            operator: 'equals',
            values: [record[currentDataSetName + '.' + measure]]
          }
        })
      ]

      if (parentFilters.length > 0) {
        const measureListReponse = await getMeasuresList({ dataSetId: report.dataSetId?._id });
        const measureList = measureListReponse?.result;
        if (measureList.length > 0) {
          const measureListName = measureList.map(measure => measure?.name);
          //console.log(measureListName)
          parentFilters.forEach((filter, index) => {
            const measureName = filter?.member?.split('.')[1];
            if (!measureListName.includes(measureName)) return;
            const filterExistInCurrentReportIndex = report?.reportFilters?.findIndex(reportFilter => reportFilter?.member?.split('.')[1] === measureName && reportFilter?.operator === filter?.operator);
            if (filterExistInCurrentReportIndex > -1) {
              combindedFilter[filterExistInCurrentReportIndex].values = filter?.values ? [...new Set([...combindedFilter[filterExistInCurrentReportIndex].values, ...filter?.values])] : [...new Set([...combindedFilter[filterExistInCurrentReportIndex].values])]
              return;
            }
            combindedFilter.push({
              member: hyperlinkDatasetName + '.' + measureName,
              operator: filter?.operator,
              values: filter?.values
            });
          });
        }
      }
      report.reportFilters = combindedFilter;
    }   
    //console.log(query) 
    setHyperlinkType(hyperlinkType)
    setHyperlinkReportData(report)
  })
}

// in case comming filter operator is same as current filter operator then mearge the values if differet sent both of them

const formatNumberTimeField = (value, format, type) => {
  let strHr, hours, minutes, seconds;

  if (type === 'second') {
    const sec = parseInt(value, 10);
    hours = Math.floor(sec / 3600);
    minutes = Math.floor((sec - (hours * 3600)) / 60);
    seconds = sec - (hours * 3600) - (minutes * 60);
    if (hours < 10) {
      if (hours) {
        strHr = "0" + hours;
      }
      hours = "0" + hours;
    }
    else {
      strHr = hours
    }
    if (minutes < 10) { minutes = "0" + minutes; }
    if (seconds < 10) { seconds = "0" + seconds; }
  }
  else if (type === 'minute') {
    const min = parseFloat(value, 10);
    hours = Math.floor(min / 60);
    minutes = Math.floor((min - ((hours * 3600)) / 60));
    seconds = Math.floor((min * 60) - (hours * 3600) - (minutes * 60));

    if (hours < 10) {
      if (hours) {
        strHr = "0" + hours;
      }
      hours = "0" + hours;
    }
    else {
      strHr = hours
    }

    if (minutes < 10) { minutes = "0" + minutes; }
    if (seconds < 10) { seconds = "0" + seconds; }
  }
  else if (type === 'hour') {
    const hr = parseFloat(value, 10);
    hours = Math.floor(hr);
    minutes = (Math.abs(hr) - hours) * 60
    seconds = (Math.abs(minutes) - Math.floor(minutes)) * 60

    if (hours < 10) {
      if (hours) {
        strHr = "0" + hours;
      }
      hours = "0" + hours;
    }
    else {
      strHr = hours
    }
    if (minutes < 10) { minutes = "0" + minutes; }
    if (seconds < 10) { seconds = "0" + seconds; }
  }

  let formatted;

  switch (format) {
    case 'hh:mm:ss':
      formatted = hours + ':' + minutes + ':' + seconds;
      break;
    case 'HH:MM:SS':
      if (strHr) {
        formatted = `${hours}hour : ${minutes}minute : ${seconds}second`
      }
      else {
        formatted = `${minutes}minute : ${seconds}second`
      }
      break;
    default:
      formatted = value
      break;
  }
  return formatted;
}

const TypeToMemoChartComponent = Object.keys(TypeToChartComponent)
  .map((key) => ({
    [key]: React.memo(TypeToChartComponent[key]),
  }))
  .reduce((a, b) => ({ ...a, ...b }));



const renderChart = (Component) => ({ resultSet, error, ...props }) => {
  if (props?.loadingState?.isLoading) {
    if (props?.chartType === 'number') {
      return <Box className="width-100">
        <Skeleton className='progress-skeleton' animation="wave" />
        <Skeleton className='progress-skeleton half' animation="wave" />
      </Box>
    }
    return <Box className="width-100">
      <Skeleton className='progress-skeleton' animation="wave" />
      <Skeleton className='progress-skeleton half' animation="wave" />
      <Skeleton className='progress-skeleton quarter' animation="wave" />
    </Box>
  }

  if (resultSet) {
    if ((props?.chartType === "numberGraphicCard") || (props?.chartType === "number" && props?.settings?.numberChartTemplate?.template === 'template4')) {
      return <Component resultSet={resultSet} {...props} />
    }
    let data;
    if (resultSet?.queryType === 'blendingQuery') {
      data = resultSet?.decompose();
    } else {
      data = resultSet.rawData();
    }
    let hasData = data.length > 0 && data[0] && data[0] !== 0 && data[0] !== null;
    if (!hasData) {
      switch (props.chartType) {
        case 'number':
          return <Box className="width-100 text-center" >
            <Box>
              <Typography className="er-report-data-info" variant='h4'>{handleLanguageChange(props?.noDataText || 'No Data Found')}</Typography>
            </Box>
          </Box>
        case 'table':
          return <Component resultSet={resultSet} {...props} />
        default:
          return <Box className="width-100 text-center " >
            <Box className='er-report-data-icon'><ReportChart /></Box>
            <Box>
              <Typography className="er-report-data-info" variant='h4'>{handleLanguageChange(props?.noDataText || 'No Data Found')}</Typography>
            </Box>
          </Box>
      }
    } else if (data.length > 0 && !Object.keys(data[0]).length) {
      return <Box className="width-100 text-center" >
        {(props.chartType != 'number') ?
          <Box className='er-report-data-icon'><ReportChart /></Box>
          : null}
        <Box className={(props.chartType === 'number' && props.viewMode === 'report') ? "er-report-error2" : props.chartType === 'number' ? "er-report-error1" : "er-report-error2"}>
          <Typography className="er-report-data-info" variant='h4'>{handleLanguageChange(props?.noDataText || 'No Data Found')}</Typography></Box>
      </Box>
    } else {
      return <Component resultSet={resultSet} {...props} />
    }
  }
  else {
    if (error && error.toString()) {
      return <Box display="flex" justifyContent="flex-start" alignItems="center">
        <Typography className='report-error-txt' color='error'> Some Thing Went Wrong! <span className='cm_info' title={error.toString()} >(i)</span>  </Typography>
      </Box>
    }

    return <Box className="width-100">
      <Skeleton className='progress-skeleton' animation="wave" />
      <Skeleton className='progress-skeleton half' animation="wave" />
      <Skeleton className='progress-skeleton quarter' animation="wave" />
    </Box>
  }
}


let compareDatesFormatChange = (dates) => {
  let newDates = []

  dates.map(dateStr => {
    if (dateStr?.type === 'custom') {
      if (dateStr?.startDate && dateStr?.endDate) {
        let startDate = new Date(dateStr?.startDate)
        let endDate = new Date(dateStr.endDate)
        let newDate = [startDate, endDate]
        newDates.push(newDate)
      }
    }
    else if (dateStr?.fixedValue) {
      newDates.push(dateStr?.fixedValue)
    }
  })

  return newDates?.length ? newDates : dates
}


// const getPaginatedData = (data, current, pageSize) => {
//   return data?.slice((current - 1) * pageSize, current * pageSize);
// };

const ChartRenderer = ({ vizState = {}, getPivotColState, gridColumnApi, setGridColumnApi, openToolBar = true, QueryRendererProps, h = null, reportIn = null, hasFilters = null, mes, setCurrPage, currpage, updateReportOrderBy, tableColumnnsView, SecondQueryRendererProps, hasLinkedReports = null, reportOfLinkedType = null, multipleQueryObj = null, combinedResults = null }) => {
  const location = useLocation()
  const isDashboardView = location.pathname.includes('embedDashboard') || location.pathname.includes('dashboardView');
  const { comparisonChartType } = useComparisonChartDetails()
  const [hyperlinkModal, setHyperlinkModal] = useState(false);
  const [hyperlinkReportData, setHyperlinkReportData] = useState(null);
  const [hyperlinkExtUrl, setHyperlinkExtUrl] = useState('')
  const [hyperlinkType, setHyperlinkType] = useState('')
  const [loader, setLoader] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [extReportType, setExtReportType] = useState("")
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState()
  const TABLE_PAGE_SIZE = 20;
  const reportDetails = useReportDetails();
  const { quickFilterList } = useQuickFilter();
  const [errorString, setErrorString] = useState(QueryRendererProps?.error?.toString() ?? '')
  const handleCategoryData = useCallback((resultSet, dateFieldFormat, pivotConfig, timeDimensionDateFormat) => {
    const reportTimedimesions = reportDetails?.reportDetails?.timeDimensions;
    const dimensions = Object.keys(resultSet?.decompose()?.[0]?.annotation()?.dimensions)
    const rawData = resultSet.tablePivot(pivotConfig)
    const categoriesData = []
    let result = {};

    let { timeDimensions } = resultSet.decompose()?.[0]?.decompose()?.[0]?.query();
    let labels = []
    if (timeDimensions?.length) {
      let { granularity } = timeDimensions[0]
      let dateFormat = 'DD MMM YY'
      switch (granularity) {
        case 'hour':
          dateFormat = dateFormat + " HH"
          break;
        case 'minute':
          dateFormat = dateFormat + " HH:mm"
          break;
        case 'second':
          dateFormat = dateFormat + " HH:mm:ss"
          break;
        case 'day':
          dateFormat = "DD MMM YY"
          break;
        case 'week':
          dateFormat = "DD MMM YY"
          break;
        case 'month':
          dateFormat = "MMM YY"
          break;
        case 'year':
          dateFormat = "YYYY"
          break;
        default:
          dateFormat = "YYYY"
          break;
      }

      labels = resultSet?.categories(pivotConfig)?.map((c) => formatXAxisValues(c.x, reportTimedimesions?.[0]?.dateFormat || dateFormat, timeDimensionDateFormat,))

      return { categories: labels }
    }

    for (let ele of rawData) {
      let value = []

      if (dateFieldFormat && Object.keys(dateFieldFormat).length) {
        for (let [key, val] of Object.entries(dateFieldFormat)) {
          let [field, type] = key.split('_')
          if (ele[field] && type === 'date') {
            let formatted = moment(ele[field])
            if (formatted.isValid()) {
              ele[field] = formatted.format(val)
            }
          }
          else if (ele[field]) {
            const formatted = formatNumberTimeField(ele[field], dateFieldFormat[key], type);
            ele[field] = formatted
          }
        }
      }

      for (let dim of dimensions) {
        if (ele[dim])
          value.push(ele[dim])
      }
      categoriesData.push(value.join(','))
    }

    result.categories = categoriesData
    return result;
  }, [reportDetails])


  const closeHyperlinkModal = () => {
    setHyperlinkModal(false);
    setHyperlinkReportData(null);
  }
  let { query, chartType, pivotConfig = null, columnState, isPivotEnabled = true, columnTitle, dateFieldFormat, isLegendVisible = true, legendPosition, columnDisplayName, fieldFormat, noDataText, reportHyperlink, settings, viewMode, toggleToTable, reportName, description, fieldsKeyInfo, backgroundColor, timeDimensionDateFormat, hiddenFields = [], rateChangeQuery, orderBy } = vizState;
  settings = settings || {}
  const component = TypeToMemoChartComponent[toggleToTable ? 'table' : chartType];
  pivotConfig = {
    ...pivotConfig,
    fillMissingDates: reportDetails?.reportDetails?.settings?.fillMissingDates ?? false
  }

  if(multipleQueryObj){
    let x = []
    let y = []
    Object.values(multipleQueryObj).forEach((value,i) => {
      value?.dimensions?.forEach(dimension => {
        x.push(dimension)
      })
      value?.measures?.forEach(measure => {
        y.push(measure)
      })
     })
  
     pivotConfig = {
      ...pivotConfig,
      x:x,
      y:y
     }
  }
  //console.log(reportDetails,pivotConfig)
  if (!LimitAllowedIn.includes(chartType) && query?.limit && !settings?.topBottomFilter)
    delete query.limit

  if (query?.timeDimensions) {
    let updatedTimeDimensions = []
    query?.timeDimensions.map(obj => {
      let { dimension, dateRange, granularity, dateRangeArray, compareDateRange } = obj

      dateRangeArray = dateRangeArray?.length ? [UtcToLocalDate(dateRangeArray[0]), UtcToLocalDate(dateRangeArray[1])] : undefined
      compareDateRange = compareDateRange?.length ? compareDatesFormatChange(compareDateRange) : undefined

      updatedTimeDimensions.push({
        dimension,
        dateRange: dateRange || dateRangeArray,
        granularity: granularity === "null" ? null : granularity,
        compareDateRange,
      })
    })
    query.timeDimensions = updatedTimeDimensions
  }

  useEffect(() => {
    //console.log(QueryRendererProps.error)
    if (QueryRendererProps.error) {
      setErrorString(QueryRendererProps.error.toString())
    }

  }, [QueryRendererProps.error]);

  useEffect(() => {
    if (errorString) {
      let DateTimeSeconds = new Date().setMilliseconds(0)
      let userUUID = localStorage.getItem('uuid')
      userUUID = userUUID ? DecryptData(userUUID) : ''

      let trackingEvent = {
        em_guid: userUUID,
        uuid: userUUID,
        landing_page: window?.location?.href ?? '',
        action: "Cube Request Error",
        date_time: new Date(DateTimeSeconds).toISOString(),
        platform: "Report-Engine",
        envirnment: EnvSettings?.env,
        app_version: EnvSettings?.version,
        browser: navigator?.userAgent,
        os_details: navigator?.platform,
        event_type: "Page-View",
        eventStep: "Cube Request Error",
        click_type: "Page-View",
        value: errorString,
      }

      userActivityLog(trackingEvent) //to track error
    }

  }, [errorString])
  //console.log(hyperlinkExtUrl)
  useEffect(() => {
    //console.log(QueryRendererProps,vizState)
  }, [QueryRendererProps?.resultSet])

  const rSettings = reportDetails?.reportDetails?.settings;
  var reportGridBgColor;
  var reportHasGridBgColor;

  if (isMobileView()) {
    reportGridBgColor = rSettings?.mobile?.reportShowGridBackgroundColor ? rSettings?.mobile?.reportGridBgColor : null;
    reportHasGridBgColor = rSettings?.mobile?.reportShowGridBackgroundColor
  } else {
    reportGridBgColor = rSettings?.web?.reportShowGridBackgroundColor ? rSettings?.web?.reportGridBgColor : null;
    reportHasGridBgColor = rSettings?.web?.reportShowGridBackgroundColor
  }

  return (
    <Box className={(reportDetails?.reportDetails?.comparisonChartType || (quickFilterList && quickFilterList.length)) ? `compareboxMain ` : ``}>
      <Box className={`dash-report-wrapper `
        + (reportDetails?.reportDetails?.comparisonChartType ? ` dash-report-compchart-wrapper ` : ` `)
        + ((quickFilterList && quickFilterList.length) ? ` dash-report-quickchart-wrapper ` : ` `) + ((reportHasGridBgColor && reportGridBgColor) ? ` dash-report-has-grid-bg ` : ` `)
      }
        sx={{
          backgroundColor: (reportHasGridBgColor ? reportGridBgColor : 'transparent'),
          borderRadius: '0px',
          padding: (reportHasGridBgColor ? '20px !important' : 0),
          // height: ((chartType === 'table' && !isMobileView()) ? ((reportDetails?.reportDetails?.h * 10) + ((reportDetails?.reportDetails?.h - 1) * 20) + 'px') : 'auto'),
        }}
      >
        <Box className='dash-report-filters-main'>
          <ChartsQuickFilter />
          <ComparisonChartSideComponent />
        </Box>
        <Box
          className={
            (reportDetails?.reportDetails?.comparisonChartType ? ` dash-report-compchart ` : ` `)
            + ((quickFilterList && quickFilterList.length) ? ` dash-report-quickchart ` : ` `)
          }
          sx={{
            flexGrow: 1,
            width: '100%',
            height: (reportDetails?.reportDetails?.chartType === 'numberGraphicCard' ? '100%' : 'inherit')
          }}
        >
          {
            (reportDetails?.reportDetails?.comparisonChartType || quickFilterList?.length > 0)
              ? <>
                <Grid container className={`dash-report-header-container ` + chartType} >
                  <Grid item xs={12}>
                    <Typography variant="h6" className="ed-report-title" title={handleLanguageChange(reportDetails?.reportDetails?.reportName)}
                    > {handleStringLength(handleLanguageChange(reportDetails?.reportDetails?.reportName), ReportCardTitleLength)} </Typography>
                  </Grid>
                  {
                    reportDetails?.reportDetails?.description
                      ? <Grid item xs={12}>
                        <Typography variant="subtitle2" className="ed-report-subtitle" title={handleLanguageChange(reportDetails?.reportDetails?.description)}
                        > {handleStringLength(handleLanguageChange(reportDetails?.reportDetails?.description), ReportCardDescriptionLength)} </Typography>
                      </Grid>
                      : null
                  }
                </Grid>
              </>
              : null
          }

          {
            component && renderChart(component)({location, pivotConfig, ...QueryRendererProps, query, columnState, getPivotColState, gridColumnApi, setGridColumnApi, openToolBar, isPivotEnabled, columnTitle, dateFieldFormat, isLegendVisible, legendPosition, columnDisplayName, fieldFormat, noDataText, chartType, reportHyperlink, settings, setHyperlinkModal, setHyperlinkReportData, setLoader, setHyperlinkExtUrl, setHyperlinkType, setUserInfo, setExtReportType, viewMode, reportName, description, fieldsKeyInfo, backgroundColor, currentPage, setCurrentPage, TABLE_PAGE_SIZE, timeDimensionDateFormat, hiddenFields, h, reportIn, hasFilters, hasLinkedReports, COLORS_SERIES, handleCategoryData, rateChangeQuery, comparisonChartType, currpage, setCurrPage, orderBy, updateReportOrderBy, tableColumnnsView, reportDetails, reportOfLinkedType, combinedResults ,isDashboardView})
          }
          {
            (hyperlinkReportData || hyperlinkExtUrl || extReportType == 'getUserInfoByUuid') && <ReportHyperLink hyperlinkModal={hyperlinkModal} closeHyperlinkModal={closeHyperlinkModal} loader={loader} hyperlinkReportData={hyperlinkReportData} hyperlinkType={hyperlinkType} hyperlinkExtUrl={hyperlinkExtUrl} userInfo={userInfo} extReportType={extReportType} chartType={chartType} isTable={toggleToTable ? true : false} reportIn={reportIn} h={h} hasFilters={hasFilters} hasLinkedReports={hasLinkedReports} comparisonChartType={comparisonChartType} />
          }
        </Box>
      </Box>
    </Box>
  )
};

export default ChartRenderer;
